import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogComponentBase } from '@wephone-core-ui';
import { _tk, _ti } from '@wephone-translation';

@Component({
  selector: 'enterprise-contacts-modal',
  templateUrl: './enterprise-contacts-modal.html',
  styleUrls: ['./enterprise-contacts-modal.scss']
})
export class EnterpriseContactsModalComponent extends DialogComponentBase implements OnInit {
  dialogTitle = _tk('tab_navigation_menu.enterprise_contact');

  constructor(dialogRef: MatDialogRef<EnterpriseContactsModalComponent>, cdr: ChangeDetectorRef) {
    super(dialogRef, cdr);
  }
}
